import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { educationData } from "../data/EducationData";

export const Education = () => {
  return (
    <div className='education'>
      <Container>
        <Row>
          <Col lg='5' className='p-0'>
            <div className='left-content'>
              <img src={educationData.image} alt='myimage' />
            </div>
          </Col>
          <Col lg='7' className='place'>
            <div className='right-content'>
              <h1>{educationData.title}</h1>
              <p>{educationData.description}</p>
            </div>
          </Col>
        </Row>
        <div className='education-data-section'>
          <div>
            <h1>{educationData.subTitle}</h1>
          </div>
          <Row className="align-center">
            {educationData.data.map((data, i) => {
              return (
                <>
                  <Col lg='4'>
                    <img src={data.eduImg} alt='imag' />
                  </Col>
                  <Col lg='8'>
                    <div key={i} className='edu-content'>
                      <div className="edu-head"><h3>{data.institution}</h3></div>
                      <p>{data.course}</p>
                      <small>{data.startYear + " - " + data.endYear}</small>
                    </div>
                  </Col>
                </>
              );
            })}
          </Row>
        </div>
      </Container>
    </div>
  );
};
